import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { manageBadgesQueryClient } from "../application/queryClients";
import { AppQueryClientProvider } from "../application/AppQueryClientProvider";

import Container from "@mui/material/Container";

import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";
import ManageBadgesBrowse from "./ManageBadgesBrowse";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },
}));

const ManageBadges = () => {
  const classes = useStyles();

  return (
    <Container id="manage-badges" classes={{ root: classes.panel }}>
      <ApplicationHeader />

      <ApplicationPanel background="white" height="calc(100vh - 200px)">
        <AppQueryClientProvider client={manageBadgesQueryClient}>
          <ManageBadgesBrowse />
        </AppQueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageBadges;
